import { motion } from 'framer-motion';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Vaciado de pisos',
      description:
        'Servicio completo de vaciado de viviendas. Retiramos muebles, electrodomésticos y enseres.',
      link: '/servicios#vaciado-pisos-casas',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Vaciado de locales',
      description:
        'Vaciado profesional de locales comerciales, oficinas y espacios de negocio.',
      link: '/servicios#vaciado-locales',
    },
    {
      icon: 'ri-archive-line',
      title: 'Vaciado de trasteros',
      description:
        'Limpieza y vaciado completo de trasteros, garajes y espacios de almacenamiento.',
      link: '/servicios#vaciado-trasteros',
    },
    {
      icon: 'ri-truck-line',
      title: 'Retirada de muebles',
      description:
        'Recogida y transporte de muebles y electrodomésticos. Gestión responsable de residuos.',
      link: '/servicios#retirada-muebles',
    },
    {
      icon: 'ri-brush-line',
      title: 'Limpieza final',
      description:
        'Limpieza profunda tras el vaciado. Dejamos el inmueble impecable y listo para entregar.',
      link: '/servicios#limpieza-final',
    },
    {
      icon: 'ri-tools-line',
      title: 'Pintura y reparaciones',
      description:
        'Coordinamos servicios de pintura y pequeñas reparaciones para renovar tu inmueble.',
      link: '/servicios#pintura-reparaciones',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-orange-bg text-orange text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4">
            Nuestros servicios
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-5">
            ¿Qué necesitas vaciar?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Ofrecemos soluciones completas de <a href="/servicios" className="text-orange hover:underline font-medium">vaciado de inmuebles en Barcelona</a>. 
            Desde pisos y casas hasta locales comerciales y trasteros.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.a
              key={index}
              href={service.link}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group bg-white border border-gray-200 rounded-2xl p-8 hover:border-orange hover:shadow-xl transition-all cursor-pointer"
            >
              <div className="w-16 h-16 bg-orange-bg rounded-2xl flex items-center justify-center mb-6 group-hover:bg-orange group-hover:scale-110 transition-all">
                <i className={`${service.icon} text-3xl text-orange group-hover:text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-3 group-hover:text-orange transition-colors">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{service.description}</p>
              <span className="inline-flex items-center text-orange font-medium text-sm group-hover:gap-2 transition-all">
                Más información
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a
            href="/servicios"
            className="inline-flex items-center border-2 border-navy text-navy px-8 py-4 rounded-full font-medium hover:bg-navy hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            Ver todos los servicios
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
